import { Address } from './address.model';

export interface OwnerPartner {
  title: string;
  partnerNumber: string;
  name: string;
  telephoneNumber: string;
  email: string;
  address: Address;
}
